
/**
 * @fileOverview Search Type Ahead Controller Module
 * @Author: Pat
 * @modified 03/05/2015
 *
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;


    define('controllers/SearchTypeAheadController',['require','jquery','lib/Util','GlobalEventDispatcher','GlobalResizeListener'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');
	    var GlobalEventDispatcher = require('GlobalEventDispatcher');
	    var GlobalResizeListener = require('GlobalResizeListener');


        var SearchTypeAhead = function (trigger) {
        	this.searchInput = trigger;
			this.taWrapper = $('<ul class="MMM--typeAhead js-typeAhead"></ul>');
			this.searchForm = this.searchInput.parents('.MMM--searchBar');
			this.dimensionID = window.SETTINGS.TypeAheadDimension;

			// Black listed characters can cause server issues if the query is submitted
			this.blChars = {
				'35': '#',
				'38': '&',
				'61': '='
			};

			this.init();
        };

		SearchTypeAhead.prototype.init = function(){
			// Set Autocomplete to 'off' so that the browser type ahead doesn't trigger
			this.searchInput.attr('autocomplete', 'off');
			this.taWrapper.insertAfter(this.searchInput);

			this.setupHandlers();

			$debug('Initializing Search Type Ahead Controller Module...', 'TypeAheadController');

			return this;
		};

		SearchTypeAhead.prototype.setupHandlers = function(){
			var self = this;

			// There are several characters that cause issues in search if they are submitted, detect these on keypress and suppress them
			this.searchInput.on('keypress', function(event){
				if(!!event.which){
					$.each(self.blChars, function(param, value){
						if(event.which.toString() === param){
							event.preventDefault();
							$debug('Illegal search character detected: ' + value, 'TypeAheadController');

							return false;
						}
					});
				}
			});

			// We want to ensure that if the search term has more than one space-delimitted word, each word must have at least three characters
			this.searchInput.on('keyup', function(event){
				var sInput = self.searchInput.val(),
					siSplit = sInput.split(' '),
					taMin = false,
					i,
					l;

				// Check for black listed characters in case the user somehow bypassed the keypress event
				$.each(self.blChars, function(param, value){
					if(sInput.indexOf(value) > -1){
						$debug('Illegal search character detected: ' + value, 'TypeAheadController');

						return false;
					}
				});

				// Check each term for a minimum of three characters
				for(i=0,l=siSplit.length;i<l;i++){
					if(siSplit[i].length > 2){
						taMin = true;
					} else{
						taMin = false;
					}
				}

				// If all terms meet the minimum length requirement, then fire the type ahead API
				if(taMin){
					self.getTA(sInput);
				}
				// Otherwise, hide the type ahead suggestions
				else{
					self.taClose();
				}
			});

			$('body').on('click', function(event){
				if(!self.taClick(event) && !self.searchClick(event)){
					self.taClose(event);
				}
			});

			return this;
		};

		SearchTypeAhead.prototype.getTA = function(searchTerm){
			var self = this,
				ajaxUrl = '/wps/PA_Snaps286/AjaxServlet?D=' + searchTerm + '*&rt=ta&loc=' + $('meta[name="DCSext.locale"]').attr('content') + '&gblid=3M%20Design%20Patterns/SNAPS/Global/Global%20Configuration';

			if(this.dimensionID !== undefined){
				$debug('Type Ahead Dimension ID override found: ' + this.dimensionID, 'TypeAheadController');
				
				ajaxUrl += '&restrict_type_ahead_dim_id=' + this.dimensionID;
			}

			/* Need this for Platinum 414 since the data is in JSON format */
			if(urlHash['setPageJS'] === 'dev' && location.hostname.indexOf('fuze.mmm.com') > -1){
				ajaxUrl = 'includes/typeAhead.json'
			}

			$.ajax({
				url: ajaxUrl,
				success: function(data, status, jqxhr){self.addTAs(data)},
				error: function(jqxhr, status, message){self.taError(message)}
			});

			return this;
		}

		SearchTypeAhead.prototype.addTAs = function(data){
			var self = this,
				hasResults = false;

			this.taWrapper.html('');

			$.each(data.results, function(param, value){
				var $taSuggestWrap = $('<li class="js-typeAheadLink"></li>'),
					$taSuggest = $('<a href="#"></a>');

				$taSuggest.attr('data-value', param).text(value);

				$taSuggest.on('click', function(event){
					event.preventDefault();
					self.taSearch($(this));
				});

				self.taWrapper.append($taSuggestWrap.append($taSuggest));
				hasResults = true;
			});

			// Show the type ahead container and position it to line up with the search input
			// Only show if there's data
			if(hasResults){
				if (this.searchInput.position()) {
					$debug('search found...', 'TypeAheadController');
					this.taWrapper.show().css({left: this.searchInput.position().left});	
				}
				else {
					$debug('no search position found...', 'TypeAheadController');
				}
			} else{
				this.taWrapper.hide();
			}

			return this;
		}

		SearchTypeAhead.prototype.taError = function(message){
			$debug('Type Ahead Ajax Failed - ' + message, 'TypeAheadController');

			return this;
		}

		SearchTypeAhead.prototype.taSearch = function($element){
			var nVal = $element.attr('data-value'),
				$nSelect = this.searchForm.find('input[name=N], select[name=N]'),
				$nInput = $('<input type="hidden" name="N" value=""></input>'),
				$fromInput = $('<input type="hidden" name="from" value="typeAhead"></input>'),
				$rtInput = this.searchForm.find('input[name=rt]'),
				$searchSubmit = this.searchForm.find('button[type=submit]');

			// If there's already a form element with name "N" we need to rename it first and get its value
			if($nSelect.length > 0){
				$nSelect.attr('name', '');
				nVal += ' ' + $nSelect.val();
			}

			// We don't want the Ntt parameter to carry through either
			// TODO: Determine if we do or do not want to send Ntt, for now clear it
			//this.searchInput.val($element.text());
			this.searchInput.remove();

			// Change the rt parameter from rs to r3 to send the user to a gallery page
			$rtInput.val('r3');

			// Append the final N value to the new input and search
			this.searchForm.append($nInput.val(nVal), $fromInput);
			$searchSubmit.click();

			return this;
		}

		SearchTypeAhead.prototype.taClose = function(event){
			this.taWrapper.hide();

			return this;
		}

		SearchTypeAhead.prototype.taClick = function(event){
			return ($(event.target).hasClass('js-typeAhead') || $(event.target).parents('.js-typeAhead').length > 0)
		}

		SearchTypeAhead.prototype.searchClick = function(event){
			return ($(event.target).hasClass('js-searchInput') || $(event.target).parents('.js-searchInput').length > 0)
		}

        return SearchTypeAhead;
    });

}(MMMRequire));